/**
 * The brand lockup, in the two sizes the app needs.
 *
 * The header uses the emblem beside live text rather than a shrunken version
 * of the full lockup: at 30px tall the lockup's wordmark is about 11px, which
 * is legible only in the sense that you already know what it says. Text stays
 * text, so it scales with the reading preferences and is selectable.
 */
/**
 * Path to a file in `public/`, honouring the build's base.
 *
 * Exported because more than one component now needs it, and a second copy
 * would be a second thing to forget when the app is mounted under a path
 * prefix — which it is, on the LAN deployment.
 */
export const asset = (file: string) => `${import.meta.env.BASE_URL}${file}`;

/** Header brand. The emblem is decorative — the adjacent word carries the name. */
export function BrandMark() {
  return (
    <span className="brand">
      <img className="brand-mark" src={asset('hazelled-mark.png')} alt="" width={36} height={30} />
      <strong>Hazelled</strong>
    </span>
  );
}

/**
 * Full lockup for the sign-in screen, where there is room for it.
 * Decorative: the header already announces the product, and the page has its
 * own heading, so a third announcement would just be noise.
 */
export function BrandLockup() {
  return (
    <img
      className="brand-lockup"
      src={asset('hazelled-logo.png')}
      alt=""
      width={600}
      height={300}
    />
  );
}

/**
 * Sign-in hero. Purely decorative, and explicitly not required to understand
 * or use the page — so it carries an empty alt and is hidden from assistive
 * technology rather than described at length.
 */
export function BrandHero() {
  return (
    <div className="hero" aria-hidden="true">
      <img
        className="hero-img"
        src={asset('hazelled-hero.jpg')}
        alt=""
        width={1600}
        height={900}
        /* Above the fold on the landing screen, so it is not lazy-loaded. */
        loading="eager"
        decoding="async"
      />
    </div>
  );
}
